module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#longform",
      toString: function () {
        return this.url;
      }
    }